import { createSlice } from "@reduxjs/toolkit";
import { fetchQueriesItems } from "./QueriesThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const queriesSlice = createSlice({
  name: "queries",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchQueriesItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQueriesItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchQueriesItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default queriesSlice.reducer;